import { render, staticRenderFns } from "./dashboard-return-rank.vue?vue&type=template&id=0b466f7f&scoped=true&"
import script from "./dashboard-return-rank.vue?vue&type=script&lang=js&"
export * from "./dashboard-return-rank.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-return-rank.vue?vue&type=style&index=0&id=0b466f7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b466f7f",
  null
  
)

export default component.exports